import { deepzoomApi } from "./api";

export const getSlideMpp = async (caseId: number, filename: string) => {
  try {
    const { data } = await deepzoomApi.get(`/${caseId}/${filename}_slideMpp`);
    return data;
  } catch (error) {
    console.log(error);
  }
};

// 히트맵(AI attention) 오버레이: 색 없이 값만 내려받고 색은 FE 에서 입힌다.
export interface HeatmapMeta {
  slideWidth: number;
  slideHeight: number;
  boundsX: number;
  boundsY: number;
  boundsWidth: number;
  boundsHeight: number;
  size0: number;
  originX: number;
  originY: number;
  extentWidth: number;
  extentHeight: number;
  imageWidth: number;
  imageHeight: number;
  patchCount: number;
  histogram: number[];
  prediction?: HeatmapPrediction | null; // 슬라이드 단위 AI 판정 (없으면 null)
}

export interface HeatmapPrediction {
  pred: string;
  probs: Record<string, number>;
  nPatches: number;
}

// 히트맵 결과가 없는 슬라이드는 404 -> null
export const getHeatmapMeta = async (caseId: number, filename: string): Promise<HeatmapMeta | null> => {
  try {
    const { data } = await deepzoomApi.get<HeatmapMeta>(`/heatmap/${caseId}/${filename}/meta`);
    return data;
  } catch {
    return null;
  }
};

export const getHeatmapValues = async (caseId: number, filename: string): Promise<Blob> => {
  const { data } = await deepzoomApi.get<Blob>(`/heatmap/${caseId}/${filename}/values.png`, {
    responseType: "blob",
  });
  return data;
};

export interface SlideQCResult {
  valid: boolean;
  error?: string;
  level_count: number | null;
  dimensions: number[] | null;
  corrupted_tiles: { level: number; col: number; row: number }[];
  checked: number;
  elapsed_ms: number;
  filename: string;
}

export const checkSlideQC = async (postId: number, filename: string): Promise<SlideQCResult> => {
  const { data } = await deepzoomApi.get<SlideQCResult>(`/qc/${postId}/${filename}`);
  return data;
};
